export default "__VITE_ASSET__BesfkC1A__"